"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJackedEditor = exports.useEditorHotkeys = exports.withKeyHandlers = exports.withLinks = exports.toggleOffBlock = exports.getSelectionBlockMatch = exports.useEditor = void 0;
var is_hotkey_1 = __importDefault(require("is-hotkey"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var slate_1 = require("slate");
var slate_history_1 = require("slate-history");
var slate_react_1 = require("slate-react");
var objectUtilities_1 = require("../../../util/objectUtilities");
var Editor_static_1 = require("./Editor.static");
var Editor_style_1 = __importDefault(require("./Editor.style"));
function useEditor(initialState) {
    var _a = __read((0, react_1.useState)((0, lodash_1.uniqueId)('editor')), 2), editorKey = _a[0], setEditorKey = _a[1];
    var _b = __read((0, react_1.useState)((0, Editor_static_1.withEmptyStateFallback)(initialState)), 2), state = _b[0], setState = _b[1];
    var editor = (0, react_1.useMemo)(
    // Cast needed: https://github.com/ianstormtaylor/slate/issues/4144
    function () { return withLinks(withKeyHandlers((0, slate_react_1.withReact)((0, slate_history_1.withHistory)((0, slate_1.createEditor)())))); }, 
    // Editor needs to re-initialized once we "discard" changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editorKey]);
    return {
        editor: editor,
        state: state,
        setState: setState,
        classes: (0, Editor_style_1.default)(),
        editorKey: editorKey,
        setEditorKey: setEditorKey,
    };
}
exports.useEditor = useEditor;
function getSelectionBlockMatch(editor, block) {
    var selection = editor.selection;
    if (!selection) {
        return undefined;
    }
    var _a = __read(Editor_static_1.Editor.nodes(editor, {
        at: Editor_static_1.Editor.unhangRange(editor, selection),
        match: function (node) { return !Editor_static_1.Editor.isEditor(node) && Editor_static_1.Element.isElement(node) && node.type === block; },
    }), 1), match = _a[0];
    return match;
}
exports.getSelectionBlockMatch = getSelectionBlockMatch;
function toggleOffBlock(_a) {
    var editor = _a.editor, block = _a.block, _b = _a.splitNode, splitNode = _b === void 0 ? false : _b;
    slate_1.Transforms.unwrapNodes(editor, {
        match: function (node) { return !Editor_static_1.Editor.isEditor(node) && Editor_static_1.Element.isElement(node) && node.type === block; },
        split: splitNode,
    });
}
exports.toggleOffBlock = toggleOffBlock;
function withLinks(editor) {
    var isInline = editor.isInline, onKeyDown = editor.onKeyDown;
    editor.isInline = function (element) { return (element.type && [Editor_static_1.ElementType.Link].includes(element.type)) || isInline(element); };
    editor.onKeyDown = function (event) {
        var linkMatch = logic.getSelectionBlockMatch(editor, Editor_static_1.ElementType.Link);
        var isList = !!logic.getSelectionBlockMatch(editor, Editor_static_1.ElementType.ListItem);
        if (linkMatch && isList && (0, is_hotkey_1.default)('enter', event) && editor.selection) {
            var isAtEndOfTheLine = (function () {
                var node = (0, lodash_1.head)(linkMatch);
                if (node && !('children' in node)) {
                    return false;
                }
                var childNode = (0, lodash_1.head)(node === null || node === void 0 ? void 0 : node.children);
                if (!childNode) {
                    return false;
                }
                var text = 'text' in childNode ? childNode.text : undefined;
                if ((0, lodash_1.isNil)(text)) {
                    return false;
                }
                return text.length === editor.selection.anchor.offset;
            })();
            if (isAtEndOfTheLine) {
                event.preventDefault();
                editor.insertBreak();
                logic.toggleOffBlock({ editor: editor, block: Editor_static_1.ElementType.Link });
            }
        }
        onKeyDown(event);
    };
    return editor;
}
exports.withLinks = withLinks;
/**
 * This is tiny plugin that allows to store key events right onto the editor
 * so they can be added from anywhere there's an access to the editor context
 * to avoid prop-drilling and other things that would quickly dirty the code
 * because key events can be only added on "Editable" component
 */
function withKeyHandlers(editor) {
    var jackedEditor = editor;
    jackedEditor.isModBeingHeld = false;
    var keyRegistry = [];
    jackedEditor.addKeyDown = function (hotkeys) {
        keyRegistry.push(hotkeys);
    };
    jackedEditor.removeKeyDown = function (hotkeys) {
        var index = keyRegistry.findIndex(function (registry) { return registry === hotkeys; });
        if (index > -1) {
            keyRegistry.splice(index, 1);
        }
    };
    jackedEditor.onKeyDown = function (event) {
        if ((0, is_hotkey_1.default)('mod', event)) {
            jackedEditor.isModBeingHeld = true;
            jackedEditor.onChange();
        }
        keyRegistry.forEach(function (registry) {
            return (0, objectUtilities_1.keys)(registry).forEach(function (hotkey) {
                var _a;
                if ((0, is_hotkey_1.default)(hotkey, event)) {
                    event.preventDefault();
                    (_a = registry[hotkey]) === null || _a === void 0 ? void 0 : _a.call(registry, event);
                }
            });
        });
    };
    jackedEditor.onKeyUp = function () {
        if (jackedEditor.isModBeingHeld) {
            jackedEditor.isModBeingHeld = false;
            editor.onChange();
        }
    };
    jackedEditor.onBlur = function () {
        if (jackedEditor.isModBeingHeld) {
            jackedEditor.isModBeingHeld = false;
            jackedEditor.onChange();
        }
    };
    jackedEditor.keyRegistry = keyRegistry;
    return jackedEditor;
}
exports.withKeyHandlers = withKeyHandlers;
/**
 * Add hotkey(s) to editor
 * See https://github.com/ianstormtaylor/is-hotkey for full list what hotkey can be
 * @param hotkeys: for example: { 'mod+s': () => save() }
 */
function useEditorHotkeys(hotkeys) {
    var editor = useJackedEditor();
    (0, react_1.useEffect)(function () {
        editor.addKeyDown(hotkeys);
        return function () {
            editor.removeKeyDown(hotkeys);
        };
    }, [editor, hotkeys]);
}
exports.useEditorHotkeys = useEditorHotkeys;
function useJackedEditor() {
    return (0, slate_react_1.useSlate)();
}
exports.useJackedEditor = useJackedEditor;
var logic = {
    getSelectionBlockMatch: getSelectionBlockMatch,
    toggleOffBlock: toggleOffBlock,
};
exports.default = logic;
